import { InferGetStaticPropsType } from "next";

import { AppShell } from "@chef/feature-app-shell";
import {
  OnTheMenu,
  OnTheMenuGetStaticProps,
  OnTheMenuGetStaticPaths,
  SimpleWeekSwitcherBar,
} from "@chef/feature-my-menu";

const MenuPage = ({
  week,
  year,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <AppShell title="Veckans meny">
      <AppShell.Meta />
      <AppShell.Drawer />
      <AppShell.Header />

      <SimpleWeekSwitcherBar week={week} year={year} />

      <AppShell.DiscountBanner />

      <OnTheMenu week={week} year={year} />

      <AppShell.Footer />
      <AppShell.Sticky anchor="bottom">
        <AppShell.TabBar />
      </AppShell.Sticky>
    </AppShell>
  );
};

export const getStaticProps = OnTheMenuGetStaticProps;
export const getStaticPaths = OnTheMenuGetStaticPaths;

export default MenuPage;
